import gql from "graphql-tag";
import LockablePostFields from "../../fragments/engagement/LockablePostFields";

export default gql`
  mutation LockPost($objectId: ID!) {
    lockPost(objectId: $objectId) {
      ...LockablePostFields
    }
  }

  ${LockablePostFields}
`;
